import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import { formatCustomerOrderStatusLabel } from '#/modules/crmMgmt/customerOrder/helper/customerOrderStatus';

const CustomerOrderStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatCustomerOrderStatusLabel(status)}
    size={size}
    className={className}
  />
);

CustomerOrderStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default CustomerOrderStatusBadge;
